import { useApplicationContext } from "components-base/application-context/AppContext";
import { optionMonths, optionYears } from "utils/apis";
import Card from "components/card";
import Dropdown from "components/dropdown";
import React from "react";
import { BsCalendar } from "react-icons/bs";

const FilterByMonth = ({
  setFilterMonth,
  setFilterYear,
  defaultMonth,
  defaultYear,
}) => {
  const { filterMonth, filterYear } = useApplicationContext();
  const [open, setOpen] = React.useState(false);
  const transparent = true;

  const handleChange = (item) => {
    setFilterMonth(item);
    setOpen(false);
  };

  const handleChangeYear = (item) => {
    setFilterYear(item);
    setOpen(false);
  };

  return (
    <Card extra="rounded-xl py-2 px-2 text-center w-[700px]">
      <div className="grid grid-cols-2 justify-items-end  gap-2 ">
        <div>
          <Dropdown
            button={
              <button
                onClick={() => setOpen(!open)}
                open={open}
                className={`flex items-center text-xl hover:cursor-pointer ${
                  !transparent
                    ? "bg-none text-white hover:bg-none active:bg-none"
                    : "bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
                } linear justify-center rounded-lg font-bold transition duration-200`}
              >
                <p className=" pr-4 text-sm"> Selecciona un mes </p>
                <BsCalendar className="h-6 w-6" />
                <p className="hover:text-black flex cursor-pointer items-center gap-2 pl-5 text-gray-600 hover:font-medium">
                  {filterMonth
                    ? filterMonth.name
                    : optionMonths.find((item) => item.number === defaultMonth)
                        .name}
                </p>
              </button>
            }
            animation={
              open
                ? "origin-top-right transition-all duration-300 ease-in-out"
                : ""
            }
            classNames={`${transparent ? "top-10" : "top-18"} right-13 w-max`}
            children={
              <div className="shadow-shadow-700 z-50 w-max rounded-xl bg-white px-4 py-3 text-sm shadow-xl dark:!bg-navy-700 dark:shadow-none">
                {optionMonths.map((item) => (
                  <p
                    onClick={() => handleChange(item)}
                    key={item.name}
                    className="hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
                  >
                    <span>
                      <BsCalendar />
                    </span>
                    {item.name}
                  </p>
                ))}
              </div>
            }
          />
        </div>
        <div>
          <Dropdown
            button={
              <button
                onClick={() => setOpen(!open)}
                open={open}
                className={`flex items-center text-xl hover:cursor-pointer ${
                  !transparent
                    ? "bg-none text-white hover:bg-none active:bg-none"
                    : "bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
                } linear justify-center rounded-lg font-bold transition duration-200`}
              >
                <p className=" pr-4 text-sm"> Selecciona un año</p>
                <BsCalendar className="h-6 w-6" />
                <p className="hover:text-black flex cursor-pointer items-center gap-2 pl-5 text-gray-600 hover:font-medium">
                  {filterYear
                    ? filterYear.name
                    : optionYears.find((item) => item.number === defaultYear)
                        .name}
                </p>
              </button>
            }
            animation={
              open
                ? "origin-top-right transition-all duration-300 ease-in-out"
                : ""
            }
            classNames={`${transparent ? "top-10" : "top-18"} right-13 w-max`}
            children={
              <div className="shadow-shadow-700 z-50 w-max rounded-xl bg-white px-4 py-3 text-sm shadow-xl dark:!bg-navy-700 dark:shadow-none">
                {optionYears.map((item) => (
                  <p
                    onClick={() => handleChangeYear(item)}
                    key={item.name}
                    className="hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
                  >
                    <span>
                      <BsCalendar />
                    </span>
                    {item.name}
                  </p>
                ))}
              </div>
            }
          />
        </div>
      </div>
    </Card>
  );
};
export default FilterByMonth;
